import React, { useEffect } from "react";
import Loader from "../../components/Loader";
import { useNavigate, useParams } from "react-router";
import { useDispatch } from "react-redux";
import { logout, setCredentials } from "../../app/features/authSlice";
import { jwtDecode } from "jwt-decode";

const LoginAs = () => {
  const { email, token, lang } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const decoded = jwtDecode(token);

    const data = { email, token, type: decoded?.role };
    dispatch(logout())
    dispatch(setCredentials({ data }));
    navigate(`/${lang}/dashboard`);
    // eslint-disable-next-line
  }, [token, email, lang]);

  return (
    <div>
      <Loader />
    </div>
  );
};

export default LoginAs;
